import styled from 'styled-components';

export const Container = styled.div`
  width: fit-content;
  margin: auto;

  > div {
    align-self: center;
    display: flex;
    justify-content: center;
    object-fit: cover;

    label {
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
  
      img {
        height: 214px;
        width: 214px;
        border: 3px solid rgba(255, 255, 255, 0.3);
        background: #eee;
        object-fit: cover;
      }
  
      input {
        display: none;
      }
    }
  }

  > section {
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
  }
`;

export const DefaultAvatar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  width: 214px;
  height: 214px;
  border: 2px dashed #ddd;
  background: #fff;

  span {
    color: #ddd;
    font-size: 16px;
    font-weight: bold;
  }
`;
